/**
 * "Popular right now" row (home + Browse). Sam, Oct 14.
 *
 * HOW TO EDIT
 * - MANUAL_OVERRIDES: always shown first, in order. Use for one-off moments (a big premiere,
 *   breaking news). Add `until: 'YYYY-MM-DD'` so it drops off by itself.
 * - SEASONAL: shown when today (New York time) is inside `from`–`to` (MM-DD, inclusive; ranges
 *   may wrap the new year, e.g. 09-04 to 02-10). Optional `days` limits to weekdays
 *   (0 = Sun … 6 = Sat), e.g. Football Sunday on Sat–Mon only. Higher `weight` sorts first.
 * - EVERGREEN: fills the row when fewer than 6 seasonal items apply.
 * - `path` must exist in src/util/topicTaxonomy.json (category/topic/subtopic). `label`
 *   overrides the topic name on the tile. Heavy/unfeatured topics are always skipped.
 * - Later: set POPULAR_SOURCE = 'stats' and pass booking/search counts to popularTopicItems().
 */
export const POPULAR_SOURCE = 'config';
export const POPULAR_LIMIT = 6;

export const MANUAL_OVERRIDES = [
  // { path: 'shows/binge-shows/what-to-watch-next', label: 'The big new series', emoji: '📺', until: '2026-11-01' },
];

export const SEASONAL = [
  { path: 'hobbies/shopping-deals/black-friday-holiday-sales', label: 'Black Friday deals', emoji: '🛍️', from: '11-20', to: '12-02', weight: 9 },
  { path: 'sports/football', label: 'Football Sunday', emoji: '🏈', from: '09-04', to: '02-10', days: [6, 0, 1], weight: 10 },
  { path: 'sports/football/fantasy-football', emoji: '📋', from: '08-15', to: '01-05', weight: 6 },
  // Nov 2 refresh: 2026 World Series ended Oct 28 (Brewers won), so the window ends Nov 1.
  { path: 'sports/baseball/world-series', emoji: '⚾', from: '10-01', to: '11-01', weight: 9 },
  // Added Nov 2 (weekly refresh): Veterans Day is Wed Nov 11.
  { path: 'life/veterans-military-life', label: 'Veterans Day', emoji: '🇺🇸', from: '11-08', to: '11-11', weight: 7 },
  // Added Nov 2 (weekly refresh): GTA VI preload Nov 12, launch Nov 19, 2026. Remove after this year.
  { path: 'sports/gaming', label: 'GTA VI is almost here', emoji: '🎮', from: '11-12', to: '11-30', weight: 8 },
  // Added Oct 19 (weekly refresh): NBA opening night is Oct 20.
  { path: 'sports/basketball', label: 'NBA is back', emoji: '🏀', from: '10-20', to: '11-15', weight: 7 },
  // Added Oct 19 (weekly refresh): no Halloween topic in the taxonomy yet, so it points at Family > Holidays.
  { path: 'sports/football/super-bowl', emoji: '🏆', from: '01-25', to: '02-12', weight: 10 },
  { path: 'life/dating/valentines-day', label: 'Valentine’s Day & dating', emoji: '💘', from: '02-01', to: '02-14', weight: 9 },
  { path: 'sports/basketball/march-madness', emoji: '🏀', from: '03-10', to: '04-08', weight: 9 },
  { path: 'work/money-worries/taxes', label: 'Tax season stress', emoji: '🧾', from: '02-15', to: '04-15', weight: 7 },
  { path: 'shows/tv-movies/oscars', emoji: '🎬', from: '02-20', to: '03-20', weight: 6 },
  { path: 'life/family/thanksgiving', label: 'Thanksgiving & family', emoji: '🦃', from: '11-15', to: '11-30', weight: 9 },
  { path: 'life/family/holidays', label: 'Holidays with family', emoji: '🎄', from: '12-01', to: '12-31', weight: 8 },
  { path: 'life/major-life-changes/new-years-goals', emoji: '🎯', from: '12-26', to: '01-31', weight: 8 },
  { path: 'shows/binge-shows/what-to-watch-next', label: 'New shows to binge', emoji: '📺', from: '09-15', to: '11-15', weight: 5 },
  // Restored Oct 15: Sam allows Elections in Popular during election season (never in ads).
  { path: 'world/news-current-events/elections', emoji: '🗳️', from: '09-01', to: '11-10', weight: 6 },
];

export const EVERGREEN = [
  { path: 'life/dating', label: 'Dating & divorce', emoji: '❤️' },
  { path: 'work/career-advice', label: 'Career & mentorship', emoji: '💼' },
  { path: 'work/money-worries', label: 'Money stress', emoji: '💵' },
  { path: 'sports', label: 'Sports', emoji: '🏟️' },
  { path: 'world/news-current-events', label: 'World events', emoji: '🌎' },
  { path: 'world/tech/ai-news', emoji: '🤖' },
];
